var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value > 0)?_c('div',{staticClass:"badge-button-container"},[_c('span',{staticClass:"badge",style:({
      backgroundImage: ("url(" + (require("@/assets/icons/star-filled.svg")) + ")")
    })},[_c('span',{staticClass:"badge-number"},[_vm._v(_vm._s(_vm.value))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }